import React from 'react';
import { FaShoppingCart } from 'react-icons/fa';

const EmptyCart = ({ onClose }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center text-gray-500">
      <FaShoppingCart size={60} className="mb-4 text-gray-300" />
      <p className="text-lg font-semibold">Your cart is empty</p>
      <p className="text-sm mt-1">Start adding your favorite products!</p>
      <button
        onClick={onClose}
        className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        Continue Shopping
      </button>
    </div>
  );
};

export default EmptyCart;